"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorNumber = void 0;
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const createFormQuestion_1 = require("@opsbase/lib-form/mutations/createFormQuestion");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag/Flag"));
const IssueType_1 = require("@opsbase/lib-issue/IssueType/IssueType");
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider/Divider"));
const Horizontal_1 = require("@opsbase/web-layout/Horizontal");
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const ColorPicker_1 = __importDefault(require("@opsbase/web-pickers/ColorPicker"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../../FedController/useFedActions"));
const QuestionEditorConditionTreeButton_1 = __importDefault(require("../QuestionEditorConditionTreeButton"));
const QuestionEditorFailButton_1 = __importDefault(require("../QuestionEditorFailButton"));
const QuestionEditorIssueButton_1 = __importDefault(require("../QuestionEditorIssueButton"));
const QuestionEditorScoringButtonMenu_1 = __importDefault(require("../QuestionEditorScoringButtonMenu"));
// eslint-disable-next-line no-shadow
var Options;
(function (Options) {
    Options["LESSTHAN"] = "lessThan";
    Options["MORETHN"] = "moreThan";
})(Options || (Options = {}));
const MAX_PRECISION = 15;
exports.QuestionEditorNumber = react_1.default.memo((props) => {
    var _a, _b, _c;
    const { config, onChange, qId, qTitle } = props;
    const { doExpand, doSelectChild } = (0, useFedActions_1.default)();
    const [shouldExpand, setShouldExpand] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)('');
    const [minValue, setMinValue] = (0, react_1.useState)(String((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.minValue));
    const [maxValue, setMaxValue] = (0, react_1.useState)(String((_b = props === null || props === void 0 ? void 0 : props.config) === null || _b === void 0 ? void 0 : _b.maxValue));
    const [precisionValue, setPrecisionValue] = (0, react_1.useState)(String((_c = props === null || props === void 0 ? void 0 : props.config) === null || _c === void 0 ? void 0 : _c.precisionValue));
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    (0, react_1.useEffect)(() => {
        if (state !== config) {
            onChange(state);
            if (shouldExpand) {
                doExpand(qId, true);
                doSelectChild(qId, value);
                setShouldExpand(false);
                setValue('');
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, value, shouldExpand]);
    const handleChange = (0, react_1.useCallback)(field => v => {
        dispatch({ field, value: v });
    }, []);
    const handleChangePrecisionValue = (0, react_1.useCallback)(() => {
        handleChange(`precisionValue`)(precisionValue);
    }, [handleChange, precisionValue]);
    const handleChangeLessThanOption = (0, react_1.useCallback)((field) => handleChange(`lessThan.${field}`), [handleChange]);
    const handleChangeMoreThanOption = (0, react_1.useCallback)((field) => handleChange(`moreThan.${field}`), [handleChange]);
    const handleChangeLessThanFlag = (0, react_1.useMemo)(() => handleChangeLessThanOption('flag'), [handleChangeLessThanOption]);
    const handleChangeMoreThanFlag = (0, react_1.useMemo)(() => handleChangeMoreThanOption('flag'), [handleChangeMoreThanOption]);
    const handleChangeLessThanLabel = (0, react_1.useMemo)(() => handleChangeLessThanOption('value'), [handleChangeLessThanOption]);
    const handleChangeMoreThanLabel = (0, react_1.useMemo)(() => handleChangeMoreThanOption('value'), [handleChangeMoreThanOption]);
    const handleChangeLessThanScore = (0, react_1.useMemo)(() => handleChangeLessThanOption('score'), [handleChangeLessThanOption]);
    const handleChangeMoreThanScore = (0, react_1.useMemo)(() => handleChangeMoreThanOption('score'), [handleChangeMoreThanOption]);
    const handleChangeLessThanSubquestions = (0, react_1.useCallback)(() => {
        var _a;
        const subQuestions = state.lessThan.subQuestions;
        const enabled = subQuestions ? !subQuestions.enabled : false;
        //remove issue question if we are disabling
        const questions = subQuestions.questions
            ? enabled
                ? subQuestions.questions
                : ((_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => q.type !== FormQuestionType_1.default.ISSUE)) || []
            : [];
        const v = {
            sqId: subQuestions.sqId,
            enabled,
            questions,
        };
        dispatch({ field: 'lessThan.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.lessThan.label);
        }
    }, [state.lessThan.label, state.lessThan.subQuestions]);
    const handleChangeMoreThanSubquestions = (0, react_1.useCallback)(() => {
        var _a;
        const subQuestions = state.moreThan.subQuestions;
        const enabled = subQuestions ? !subQuestions.enabled : false;
        //remove issue question if we are disabling
        const questions = subQuestions.questions
            ? enabled
                ? subQuestions.questions
                : ((_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => q.type !== FormQuestionType_1.default.ISSUE)) || []
            : [];
        const v = {
            sqId: subQuestions.sqId,
            enabled,
            questions,
        };
        dispatch({ field: 'moreThan.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.moreThan.label);
        }
    }, [state.moreThan.label, state.moreThan.subQuestions]);
    const handleAddIssueQuestion = (0, react_1.useCallback)(subQuestions => {
        var _a;
        let questions = subQuestions.questions.filter(q => !!q.title) || [];
        const isIssueQuestionFound = (_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.some(q => q.type === FormQuestionType_1.default.ISSUE);
        if (!isIssueQuestionFound) {
            questions = questions.concat((0, createFormQuestion_1.createFormQuestion)({
                title: 'Please include details',
                type: FormQuestionType_1.default.ISSUE,
                config: {
                    [FormQuestionType_1.default.ISSUE]: {
                        title: 'Problem with ' + qTitle,
                        type: IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED,
                        flag: Flag_1.default.RED,
                    },
                },
            }));
        }
        else {
            questions = questions.filter(q => q.type !== FormQuestionType_1.default.ISSUE);
        }
        return {
            sqId: subQuestions.sqId,
            enabled: !!(questions === null || questions === void 0 ? void 0 : questions.length),
            questions: questions,
        };
    }, [qTitle]);
    const handleAddIssueQuestionToLessThan = (0, react_1.useCallback)(() => {
        const v = handleAddIssueQuestion(state.lessThan.subQuestions);
        dispatch({ field: 'lessThan.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.lessThan.label);
        }
    }, [handleAddIssueQuestion, state.lessThan.label, state.lessThan.subQuestions]);
    const handleAddIssueQuestionToMoreThan = (0, react_1.useCallback)(() => {
        const v = handleAddIssueQuestion(state.moreThan.subQuestions);
        dispatch({ field: 'moreThan.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.moreThan.label);
        }
    }, [handleAddIssueQuestion, state.moreThan.label, state.moreThan.subQuestions]);
    const handleChangeLessThanClickMarkFail = (0, react_1.useCallback)(() => {
        dispatch({ field: 'lessThan.fail', toggle: true });
    }, []);
    const handleChangeMoreThanClickMarkFail = (0, react_1.useCallback)(() => {
        dispatch({ field: 'moreThan.fail', toggle: true });
    }, []);
    const minTextFieldRef = (0, react_1.useRef)();
    const maxTextFieldRef = (0, react_1.useRef)();
    const handleChangeMinValue = (0, react_1.useCallback)(() => {
        if (parseFloat(minValue) > parseFloat(maxValue)) {
            setMinValue(null);
            setTimeout(() => minTextFieldRef.current.focus(), 100);
            handleChange('minValue')(null);
        }
        else {
            handleChange('minValue')(minValue);
        }
    }, [handleChange, maxValue, minValue]);
    const handleChangeMaxValue = (0, react_1.useCallback)(() => {
        if (parseFloat(maxValue) < parseFloat(minValue)) {
            setMaxValue(null);
            setTimeout(() => maxTextFieldRef.current.focus(), 100);
            handleChange('maxValue')(null);
        }
        else {
            handleChange('maxValue')(maxValue);
        }
    }, [handleChange, maxValue, minValue]);
    const handleOnChangeMinValue = (0, react_1.useCallback)(v => {
        if (isNaN(parseFloat(v))) {
            setMinValue(null);
        }
        else {
            const splitValue = (v + '').split('.');
            if (splitValue.length == 2 && splitValue[1].length >= 4) {
                setMinValue(splitValue[0] + '.' + splitValue[1].slice(0, 3));
            }
            else {
                setMinValue(v);
            }
        }
    }, []);
    const handleOnChangeMaxValue = (0, react_1.useCallback)(v => {
        if (isNaN(parseFloat(v))) {
            setMaxValue(null);
        }
        else {
            const splitValue = (v + '').split('.');
            if (splitValue.length == 2 && splitValue[1].length >= 4) {
                setMaxValue(splitValue[0] + '.' + splitValue[1].slice(0, 3));
            }
            else {
                setMaxValue(v);
            }
        }
    }, []);
    const handleOnChangePrecisionValue = (0, react_1.useCallback)(v => {
        if (isNaN(parseInt(v))) {
            setPrecisionValue(null);
        }
        else if (parseInt(v) > MAX_PRECISION || parseInt(v) < 0) {
            setPrecisionValue(null);
        }
        else {
            setPrecisionValue(v);
        }
    }, []);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(NumberOption, Object.assign({ label: lib_i18n_1.default.t('if-less-than'), t: Options.LESSTHAN, onChangeValue: handleChangeLessThanLabel, onChangeScore: handleChangeLessThanScore, onChangeFlag: handleChangeLessThanFlag, onMarkFail: handleChangeLessThanClickMarkFail, onClickCondition: handleChangeLessThanSubquestions, onClickAddIssueQuestion: handleAddIssueQuestionToLessThan, config: state }, props)),
        react_1.default.createElement(NumberOption, Object.assign({ label: lib_i18n_1.default.t('if-more-than'), t: Options.MORETHN, onChangeValue: handleChangeMoreThanLabel, onChangeScore: handleChangeMoreThanScore, onChangeFlag: handleChangeMoreThanFlag, onMarkFail: handleChangeMoreThanClickMarkFail, onClickCondition: handleChangeMoreThanSubquestions, onClickAddIssueQuestion: handleAddIssueQuestionToMoreThan, config: state }, props)),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(Vertical_1.default, { shrink: true },
            react_1.default.createElement(Horizontal_1.Horizontal, { centered: true },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('min-value')),
                react_1.default.createElement(TextField_1.default, { disabled: props.disabled, type: "number", inputRef: minTextFieldRef, value: String(minValue), placeholder: lib_i18n_1.default.t('min-value'), onChange: handleOnChangeMinValue, onBlur: handleChangeMinValue })),
            react_1.default.createElement(Horizontal_1.Horizontal, { centered: true },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('max-value')),
                react_1.default.createElement(TextField_1.default, { disabled: props.disabled, type: "number", inputRef: maxTextFieldRef, value: String(maxValue), placeholder: lib_i18n_1.default.t('max-value'), onChange: handleOnChangeMaxValue, onBlur: handleChangeMaxValue })),
            react_1.default.createElement(Horizontal_1.Horizontal, { centered: true },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('max-precision')),
                react_1.default.createElement(TextField_1.default, { disabled: props.disabled, type: "number", value: String(precisionValue), placeholder: lib_i18n_1.default.t('max-precision'), onChange: handleOnChangePrecisionValue, onBlur: handleChangePrecisionValue })))));
});
exports.default = exports.QuestionEditorNumber;
const NumberOption = react_1.default.memo((props) => {
    var _a;
    const { config, scoring, label, t, onChangeValue, onChangeScore, onChangeFlag, onClickCondition, onClickAddIssueQuestion, onMarkFail, immediateFailAvailable, disabled, } = props;
    const { flag, subQuestions, score, fail } = config[t];
    const [value, setValue] = (0, react_1.useState)(config[t].value);
    const isLabel = !isNaN(parseFloat(String(value)));
    const handleOnChange = (0, react_1.useCallback)(v => {
        if (isNaN(parseFloat(v))) {
            setValue(null);
        }
        else {
            const splitValue = (v + '').split('.');
            if (splitValue.length == 2 && splitValue[1].length >= 4) {
                setValue(splitValue[0] + '.' + splitValue[1].slice(0, 3));
            }
            else {
                setValue(v);
            }
        }
    }, []);
    return (react_1.default.createElement(TextField_1.default, { disabled: disabled, type: "number", fullWidth: true, value: String(value), placeholder: 'X', onChange: handleOnChange, onBlur: onChangeValue, InputProps: {
            startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                scoring ? (react_1.default.createElement(QuestionEditorScoringButtonMenu_1.default, { disabled: disabled, score: score, onChange: onChangeScore })) : null,
                label)),
            endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                react_1.default.createElement(ColorPicker_1.default, { noMargin: true, noBorder: true, disabled: disabled || !isLabel, value: flag, onChange: onChangeFlag }),
                immediateFailAvailable && (react_1.default.createElement(QuestionEditorFailButton_1.default, { disabled: disabled, enable: fail, onClick: onMarkFail })),
                react_1.default.createElement(QuestionEditorConditionTreeButton_1.default, { enable: (subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.enabled) ? subQuestions.enabled : false, isLabel: isLabel, disabled: disabled, onClick: onClickCondition }),
                react_1.default.createElement(QuestionEditorIssueButton_1.default, { enable: (subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.enabled) &&
                        ((_a = subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.questions) === null || _a === void 0 ? void 0 : _a.some(q => q.type === FormQuestionType_1.default.ISSUE)), disabled: disabled, isLabel: isLabel, onClick: onClickAddIssueQuestion }))),
        } }));
});
